<template>
    <transition name="fade-block">
        <div class="song-widget col-xs-6 p-h-5">
            <div v-if="song" class="inner-container" :class="{'liked' : isLiked, 'disliked' : isDisliked, 'playing': activeSongId == song.id}">
                <div @click="play" class="thumbnail">
                    <div :data-img="getSongImage" class="lazzyLoad"></div>
                </div>
                <div class="artist" @click="openRoute">{{ song.artist }}</div>
                <div class="name" @click="openRoute">{{ song.name }}</div>
                <div class="uploader" v-html="getTop"></div>

                <div class="info" v-html="getChart +'<br>'+ getTopName +'<br>'+ getCountry "></div>
                <div class="button button-center more" @click="showOptions = 1">
                    <i class="iconify" data-icon="zmdi:more"></i>
                </div>
            </div>

            <div v-else class="inner-container-mokup">

            </div>

            <transition name="page-overlay" class="move-to-root">
                <div class="page-overlay dark song-options" :id="oid" v-show="showOptions == 2" v-if="showOptions">
                    <div class="container">
                        <div class="row">
                            <div class="col-xs-12">
                                <ul v-if="!isOwner">
                                    <li class="button button-white" @click="showPlaylistManager()">Add to Playlist</li>
                                    <li class="button button-white" @click="toggleBlock()">{{ isBlocked ? 'Unblock' : 'Block' }} {{ isArtist ? 'artist' : 'label' }}</li>
                                    <li class="button button-white" @click="toggleFollow()">{{ isFollowed ? 'Unfollow' : 'Follow' }} {{ isArtist ? 'artist' : 'label' }}</li>
                                    <li class="button button-white" @click="toggleLike()">{{ isLiked ? 'Dislike' : 'Like' }}</li>
                                    <li class="button button-white" @click="shareMobile()">Share</li>
                                </ul>

                                <ul v-else>
                                    <!-- <li class="button button-white disabled">Edit</li> -->
                                    <li class="button button-white" @click="showPlaylistManager()">Add to Playlist</li>
                                    <li class="button button-white" @click="toggleRelease()">{{ !isReleased ? 'Release' : 'Unrelease' }}</li>
                                    <li class="button button-white" @click="togglePublish()">{{ !isPublished ? 'Publish' : 'Unpublish' }}</li>
                                    <li class="button button-white" @click="shareMobile()">Share</li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-xs-12 text-center m-t-16">
                            <div class="btn btn-round button" @click="showOptions = 3">back</div>
                        </div>
                    </div>
                </div>
            </transition>         
        </div>
    </transition>
</template>

<script>
export default {
    props: ['song', 'layout', 'origin'],

    data() {
        return {
            oid: "options_"+ this.song.id +"_"+ Math.random().toString(36).substr(2, 9),
            showOptions: 0,
            activeSongId: 0
        }
    },

    activated() {
        LazzyLoad();
        this.$root.$emit('requestCurrentSong');
        this.$root.$on('currentSongPlaying', (songId, state) => {
            this.activeSongId = state != 'stopped' ? songId : 0;
        })
    },

    mounted() {
        this.$nextTick(() => {
            LazzyLoad();
        });  

        this.$root.$emit('requestCurrentSong');
        this.$root.$on('currentSongPlaying', (songId, state) => {
            this.activeSongId = state != 'stopped' ? songId : 0;
        })
    },

    methods: {
        play() { console.log('play');
            this.$root.$emit('mp-load-song', this.song, false);
            // this.$parent.$emit('play-all', this.index);

            if ( App.user.id != this.song.uploader_id ){
                if (App.allowGtag) gtag('event', 'play_song', {
                    'event_category' : this.origin.split(".")[0],
                    'event_label' : `Play other user song from ${ this.origin.split(".")[1] }`
                });
            }
        },

        openRoute() {
            if ( App.user.id != this.song.uploader_id ){
                if (App.allowGtag) gtag('event', 'open_song', {
                    'event_category' : this.origin.split(".")[0],
                    'event_label' : `Open other user song from ${ this.origin.split(".")[1] }`
                });
            }

            App.queryParams = this.song;
            this.$router.push({path: '/song/' + this.song.id});
        },

        showPlaylistManager(){
            this.showOptions = 3;
            setTimeout(() => {
                this.$root.$emit('showPlaylistManager', this.song);    
            }, 350);
        },  

        formatNumber(value){
            if (value > 1000000) return (value / 1000000).toFixed(1) +'M';
            if (value > 1000) return (value / 1000).toFixed(1) +'K';
            if (value > 0) return value;            
        },

        toggleLike(type) {
            var review = this.song.review;
            this.song.review = this.isLiked ? 'dislike' : 'like';

            this.$http.post(this.reviewEndpoint, { review: this.song.review }).then(() => {}, (error) => { this.song.review = review; });
        },

        toggleFollow() {
            var pick = this.song.artist_pick === 'followed' ? 'unfollow' : 'follow';
            this.updatePick(pick);
        },

        toggleBlock() {
            var pick = this.song.artist_pick === 'blocked' ? 'unblock' : 'block';
            this.updatePick(pick);
        },

        updatePick(pick) {
            this.$http.post(this.updatePickEndpoint, { pick: pick }).then((success) => {
                this.song.artist_pick = success.data.data.status;
                // this.$root.$emit('pickUpdated', this.song.artist_pick, this.song.uploader.id);
            });
        },

        togglePublish() {
            var verb = this.song.released ? 'delete' : 'post';
            this.$http[verb](this.publishEndpoint).then((success) => {
                this.song.released = !this.song.released;
            });            
        },

        toggleRelease() {
            var verb = this.song.public ? 'delete' : 'post';
            this.$http[verb](this.releaseEndpoint).then((success) => {
                this.song.public = !this.song.public;
            });            
        },

        shareMobile(){
            if (navigator.share) {
                navigator.share({
                    title: `${this.song.name} - ${this.song.artist}`,
                    text: `Check out this great song from ${this.song.uploader.name}`,
                    url: this.song.url
                }).then(() => console.log('Successful share'))
                .catch(error => console.log('Error sharing:', error));
            }else{
                alert('Navigator share disabled')
            }
        }
    },

    computed: {
        getChart() {
            switch(this.song.source) {
                case 'youtubecharts': return '<img src="/img/web/song/statistics/youtube.svg"/>';
                case 'shazamcharts': return '<img src="/img/web/song/statistics/shazam.svg"/>';
                case 'spotifycharts': return '<img src="/img/web/song/statistics/spotify.svg"/>';
                default: return this.song.source;
            }
        },

        reviewEndpoint() {
            return App.restApi + '/api/song/' + this.song.id + '/review';
        },

        updatePickEndpoint() {
            return App.restApi + '/api/user/' + this.song.uploader.id + '/picks';
        },

        publishEndpoint(){
            return App.restApi + '/api/v2/songs/' + this.song.id + '/released';
        },

        releaseEndpoint(){
            return App.restApi + '/api/v2/songs/' + this.song.id + '/public';
        },

        isLiked(){ return this.song.review == 'like'; },
        isDisliked(){ return this.song.review == 'dislike'; },
        isFollowed(){ return this.song.artist_pick === 'followed'; },
        isBlocked(){ return this.song.artist_pick === 'blocked'; },
        isPublished(){ return this.song.released; },
        isReleased(){ return this.song.public; },        

        isArtist() { return this.song.uploader.type == 'artist'; },
        isLabel() { return this.song.uploader.type == 'label'; },        
        isOwner() { return App.user.id == this.song.uploader_id || App.user.id == 21; },

        getCountry() {
            return window.getCountryName(this.song.country_code);
        },

        getTop() {
            return this.song.position ? "<span class='text-dark font-s-20 font-w-600'>#"+ this.song.position +"</span>" : '-';
        },

        getTopName() {
            switch(this.song.source) {
                case 'youtubecharts': return 'Top 100';
                case 'shazamcharts': return 'Top 200';
                case 'spotifycharts': return this.song.viral ? 'Viral 50' : 'Top 200';
                default: return 'Top 100';
            }
        }, 
 
        getSongImage() {
            return App.restApi + '/api/image/' + this.song.picture_path;
        }
    },

    watch:{
        showOptions(){
            if (this.showOptions == 3){
                setTimeout(() => {
                    this.showOptions = 0;
                }, 500);
            }

            if (this.showOptions == 1){
                this.$nextTick(() => {
                    $('#musicplayer').after( $("#"+ this.oid) );
                    this.showOptions = 2; 
                });
            }
        }
    },

    beforeDestroy(){
        $("#"+ this.oid).remove();
        this.$root.$off(['currentSongPlaying']);
    }     
}
</script>
